const enforceMaxValue = (value, maxValue) => {
	const numericValue = parseFloat(value.replace(/,/g, "")) || 0;
	return Math.min(numericValue, maxValue).toFixed(2);
};

export default enforceMaxValue;
